const customerCallRegistrationRoutes = [
  {
    name: "customercallHome",
    path: "",
    component: () => import("./ListCustomerCalls.vue"),
    meta: {
      auth: true,
      title: "Calls Logs",
      breadcrumb: "Calls Logs",
      permission: ["view customercall"],
    },
  },

  {
    name: "customerConversationSearch",
    path: "search",
    component: () => import("./CustomerConversationsSearch.vue"),
    meta: {
      auth: true,
      title: "Customer Conversations",
      breadcrumb: "Customer Conversations",
      permission: ["view customercall"],
    },
  },

  {
    name: "employeeContactSummaryReport",
    path: "employee-contact-summary",
    component: () => import("./EmployeeContactSummaryReport.vue"),
    meta: {
      auth: true,
      title: "Contact Summary",
      breadcrumb: "Contact Summary",
      permission: ["view customercall"],
    },
  },

  {
    name: "followUpDisciplineReport",
    path: "follow-up-discipline",
    component: () => import("./FollowUpDisciplineReport.vue"),
    meta: {
      auth: true,
      title: "Follow-Ups",
      breadcrumb: "Follow-Ups",
      permission: ["view customercall"],
    },
  },
];

export default customerCallRegistrationRoutes;
